exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".applicant-payment .circle{width:87px;height:87px;background:#94c959;border-radius:50%;margin:0 auto 37px}.applicant-payment .circle .triangle-block{height:87px;display:table-cell;vertical-align:middle}.applicant-payment .circle .triangle-block .triangle{width:44px;height:23px;border:7px solid #fff;box-sizing:border-box;border-top:none;border-right:none;margin-left:22px;margin-top:-3px;transform:rotate(-45deg)}.applicant-payment .completed h2{color:#545454;font-size:20px;line-height:1;font-weight:600;text-align:center;margin-top:0}.applicant-payment .completed p{color:#545454;font-size:14px;line-height:1.4;margin-top:21px;text-align:left;width:100%;font-style:normal;margin:10px 0;font-weight:400;display:inline-block;max-width:470px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/payment/complete/complete.scss
// module id = 1157
// module chunks = 0